export default "__VITE_ASSET__CvOX1qyT__"